/*
  * This file is for the triggers enum. Trigger types are used to determine the type of event that occurred.
    They are mapped to a string value in the UI.
*/
export enum Triggers {
  Manual = 1,
  Erratic = 2,
  Shock = 3,
  Remote = 4,
  Safety_Open = 5,
  Safety_Close = 6,
  Fail = 7,
  Smart_Trigger = 11,
  Speed_Policy = 12,
  Lane_Departure = 15,
  Critical_Distance = 16,
  CS_Warning = 17,
  Following_Distance = 18,
  In_Lane_Fitness = 19,
  Posted_Speed = 22,
  Smart_Trigger_Soft_Deleted = 24,
  Calibration = 25,
  Rolling_Stop = 26,
  Roll_Stability = 27,
  Pedestrian = 28,
  FLEX_Smart_Trigger_Auto_Upload = 30,
  FLEX_Smart_Trigger_Shock = 31,
  FLEX_Smart_Trigger_Soft_Delete = 32,
  Handheld_Device = 2001,
  No_Seat_Belt = 2002,
  Food_Or_Drink = 2003,
  Driver_Smoking = 2004,
  Inattentive = 2005,
  Lens_Obstruction = 2006,
  Policy_Speed = 2008,
  Parked_Highway_Or_Ramp = 2009
}
